// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { useMemo } from "react";

type OwnProps = {
    cart: Cart;
};

type Props = OwnProps & HasCartLineContext;

export interface TagAlongMessageStyles {
    text?: TypographyPresentationProps;
}

export const tagAlongMessageStylesStyles: TagAlongMessageStyles = {};

const styles = tagAlongMessageStylesStyles;

const TagAlongMessage = ({ cart, cartLine }: Props) => {
    const getParentProductErpNumber = useMemo(
        () =>
            cart?.cartLines?.find(cartLineAttribute => cartLineAttribute.id === cartLine.properties.tagAlongProduct)
                ?.manufacturerItem,
        [cart?.cartLines],
    );

    if (!getParentProductErpNumber) {
        return null;
    }

    return (
        <Typography {...styles.text}>
            {translate("Required product for")} {getParentProductErpNumber}
        </Typography>
    );
};

export default withCartLine(TagAlongMessage);
